import { Component } from 'react';

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch() {}

  render() {
    if (this.state.hasError) {
      return (
        <div className="p-8 text-center" data-testid="error-boundary-fallback">
          <p className="text-charcoal font-medium mb-2">Something went wrong on this page.</p>
          <button
            data-testid="error-boundary-retry-btn"
            onClick={() => this.setState({ hasError: false })}
            className="text-coriander underline text-sm"
          >
            Try again
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
